<template>
  <div class="copilot-input">
    <textarea
      v-model="localValue"
      class="copilot-input__textarea"
      :placeholder="$t('copilot.placeholder')"
      :disabled="disabled"
      rows="3"
      @keydown.enter.exact.prevent="onEnter"
    />
    <div class="copilot-input__actions">
      <Button
        type="primary"
        size="small"
        :disabled="disabled || !canSubmit"
        append-icon="iconoir-nav-arrow-right"
        @click="onSubmit"
      >
        {{ $t('copilot.send') }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '@baserow/modules/core/components/Button'

export default {
  name: 'CopilotInput',
  components: { Button },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localValue: '',
    }
  },
  computed: {
    canSubmit() {
      return this.localValue.trim().length > 0
    },
  },
  methods: {
    onEnter() {
      if (this.canSubmit && !this.disabled) {
        this.onSubmit()
      }
    },
    onSubmit() {
      if (!this.canSubmit || this.disabled) {
        return
      }

      const value = this.localValue.trim()
      this.$emit('submit', value)
      this.localValue = ''
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../core/assets/scss/colors';

.copilot-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.copilot-input__textarea {
  width: 100%;
  min-height: 72px;
  resize: vertical;
  font-size: 13px;
  line-height: 1.5;
  padding: 10px 12px;
  box-sizing: border-box;
  border: 1px solid $palette-neutral-200;
  border-radius: 10px;
  background: $white;
  color: $palette-neutral-1300;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    border-color: $palette-blue-400;
    box-shadow: 0 0 0 3px rgba($palette-blue-500, 0.12);
  }

  &:disabled {
    background: $palette-neutral-50;
    color: $palette-neutral-500;
  }
}

.copilot-input__actions {
  display: flex;
  justify-content: flex-end;
}
</style>
